import { render } from "./indextwobanner.vue?vue&type=template&id=1272a41e"
import script from "./indextwobanner.vue?vue&type=script&lang=js"
export * from "./indextwobanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__